








import { useVideoProperties } from '@ks/player';
import { formatTime } from '../utils';
import { defineComponent } from '@vue/composition-api';
import { usePlayProgress } from '../player';
import { useBroadCastStream } from '@/common/utils';
export default defineComponent({
    props: {
        timeKeyDown: {
            type: Boolean,
            default: true,
        },
        isHorizontal: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const {
            currentTime,
            duration,
        } = useVideoProperties();

        if (props.timeKeyDown) {
            usePlayProgress(currentTime, duration, useBroadCastStream);
        }
        return {
            currentTime,
            duration,
            formatTime,
        };
    },
});
